import React, {Dispatch, FC, Fragment, ReactNode, RefObject, SetStateAction} from "react";
import cls from "./customInnerPage.module.scss";
import {IProduct} from "../../../types/homePageTypes";
import CustomProductOptions from "./CustomProductOptions";

interface IProps {
    product: IProduct;
    productName: string;
    productSkuOptionName: string;
    productSku: string;
    selectedCurrSymbol: string;
    children: ReactNode;
    priceHtmlAvailable: ReactNode;
    clientSidePrice: {
        price: string | number,
        specialPrice: string | number | null
    };
    productShortDescOptionName: string;
    productShortDesc: string;
    productOptions?: Array<{
        id: number,
        title: string,
        product_id: number,
        required: string,
        type: string,
        children: {
            id: number,
            label: string,
            admin_name: string,
            price: number | string,
            sort_order: string | number
        }
    }>;
    optionIdShowToggle: (elemId: number, elemTitle: string) => ReactNode;
    rootRef: RefObject<HTMLDivElement> | null;
    setOpen: Dispatch<SetStateAction<boolean>>;
    arrowClassName: string;
    dropdownDisplay: string;
    toggleOptionValue: (id: number, label: string, price: string, optionId: number) => void
}

const CustomInfoPart: FC<IProps> = (
    {
        product,
        productName,
        productSkuOptionName,
        productSku,
        selectedCurrSymbol,
        children,
        clientSidePrice,
        priceHtmlAvailable,
        productShortDescOptionName,
        productShortDesc,
        productOptions,
        optionIdShowToggle,
        rootRef,
        setOpen,
        arrowClassName,
        dropdownDisplay,
        toggleOptionValue
    }
) => {


    const showProductOptionOrNot: Record<string, Record<string, ReactNode>> = {
        simple: {
            true: <CustomProductOptions
                productOptions={productOptions}
                optionIdShowToggle={optionIdShowToggle}
                rootRef={rootRef}
                setOpen={setOpen}
                arrowClassName={arrowClassName}
                dropdownDisplay={dropdownDisplay}
                toggleOptionValue={toggleOptionValue}
            />,
            false: <></>
        },
        virtual: {
            true: <CustomProductOptions
                productOptions={productOptions}
                optionIdShowToggle={optionIdShowToggle}
                rootRef={rootRef}
                setOpen={setOpen}
                arrowClassName={arrowClassName}
                dropdownDisplay={dropdownDisplay}
                toggleOptionValue={toggleOptionValue}
            />,
            false: <></>
        },
        configurable: {
            true: <></>,
            false: <></>
        },
        downloadable: {
            true: <></>,
            false: <></>
        },
        bundle: {
            true: <></>,
            false: <></>
        },
    }

    const priceHandle = {
        true: <div className={cls.product__price}>
            <div className={cls["product-card__new-price"]}>
                <div className={cls.price_value}>
                    {selectedCurrSymbol}
                    {" "}
                    {clientSidePrice.specialPrice}
                </div>
            </div>
            <div className={cls["product-card__old-price"]}>
                <div className={cls.price_value}>
                    {selectedCurrSymbol}
                    {" "}
                    {clientSidePrice.price}
                </div>
            </div>
        </div>,
        false: <div className={cls.product__price}>
            <div className={cls.price_value}>
                {selectedCurrSymbol}
                {" "}
                {clientSidePrice.price}
            </div>
        </div>
    }

    const showShortDesc = {
        "true": <div className={cls["product-inner-description-title"]}>{productShortDescOptionName}</div>,
        "false": <></>
    }

    return (
        <Fragment>
            <h1 style={{textAlign: "left"}} className={cls.product__name}>{productName}</h1>
            <p className={cls.product__sku}>{productSkuOptionName}: {productSku}</p>
            {priceHandle[`${!!clientSidePrice.specialPrice}`]}
            <div>{priceHtmlAvailable}</div>
            {showShortDesc[`${productShortDesc?.length > 0}`]}
            <div dangerouslySetInnerHTML={{__html: productShortDesc}}/>
            {children}
        </Fragment>
    )
};

export default CustomInfoPart;
